export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["कल"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["चैट"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["आज"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सोमवार"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["मंगलवार"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["बुधवार"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["गुरुवार"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["शुक्रवार"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["शनिवार"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["रविवार"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["जनवरी"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["फरवरी"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["मार्च"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["अप्रैल"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["मई"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["जून"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["जुलाई"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["अगस्त"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सितंबर"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["अक्टूबर"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["नवंबर"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["दिसंबर"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["आप"])},
  "24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["व्यवस्थापक"])}
}